import { Button, Box } from '@mui/material';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

export default function OnboardingNavigationButtons({
  onBack,
  onNext,
  disabled = false,
  backDisabled = false,
  nextDisabled = false,
  loading = false,
  backId = 'back-onboard-button',
  nextId = 'next-onboard-button',
}) {
  const intl = useIntl();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
      <Button
        color="secondary"
        size="large"
        variant="outlined"
        onClick={onBack}
        disabled={disabled || backDisabled}
        id={backId}
        sx={{
          borderColor: 'secondary.main',
          color: 'secondary.main',
          backgroundColor: '#fff',
          '&:hover': { borderColor: 'secondary.dark', backgroundColor: '#f0f0f0' },
        }}
      >
        {intl.formatMessage({ id: 'forms.onboarding.back' })}
      </Button>
      <Button
        color="secondary"
        size="large"
        variant="contained"
        onClick={onNext}
        disabled={disabled || nextDisabled || loading}
        id={nextId}
      >
        {loading ? intl.formatMessage({ id: 'forms.onboarding.loading' }) : intl.formatMessage({ id: 'forms.onboarding.next' })}
      </Button>
    </Box>
  );
}

OnboardingNavigationButtons.propTypes = {
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  backDisabled: PropTypes.bool,
  nextDisabled: PropTypes.bool,
  loading: PropTypes.bool,
  backId: PropTypes.string,
  nextId: PropTypes.string,
};
